module.exports = __webpack_public_path__ + "img/enterprise_setup_2.299e8fd2.svg";